import { render, staticRenderFns } from "./singlePersonAccount.vue?vue&type=template&id=6760ef7f&scoped=true&"
import script from "./singlePersonAccount.vue?vue&type=script&lang=js&"
export * from "./singlePersonAccount.vue?vue&type=script&lang=js&"
import style0 from "./singlePersonAccount.vue?vue&type=style&index=0&id=6760ef7f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6760ef7f",
  null
  
)

export default component.exports